import * as PIXI from 'pixi.js-legacy';
import * as pixiParticles from 'pixi-particles';

class ParticleEmitter {
    emitter: pixiParticles.Emitter;
    particleContainer: PIXI.Container;

    elapsedTime: number;

    static particleTextureList: object;

    constructor(containerForParticles: PIXI.Container, symbol: string) {
        this.create(containerForParticles, symbol);    
        this.emitter.emit = false;        
    }

    static fillParticleTextureList() {
        if (!this.particleTextureList) {
            this.particleTextureList = {
                symbol_J: {
                    name: 'particle_symbol_J',
                    texture: PIXI.Texture.EMPTY,
                },
                symbol_Q: {
                    name: 'particle_symbol_Q',
                    texture: PIXI.Texture.EMPTY,
                },
                symbol_K: {
                    name: 'particle_symbol_K',
                    texture: PIXI.Texture.EMPTY,
                },
                symbol_A: {
                    name: 'particle_symbol_A',
                    texture: PIXI.Texture.EMPTY,
                },
                symbol_Bracelet: {
                    name: 'particle_symbol_bracelet',
                    texture: PIXI.Texture.EMPTY,
                },
                symbol_Shield: {
                    name: 'particle_symbol_shield',
                    texture: PIXI.Texture.EMPTY,
                },
                symbol_Axe: {
                    name: 'particle_symbol_axe',
                    texture: PIXI.Texture.EMPTY,
                },
                symbol_Helmet: {
                    name: 'particle_symbol_helm',
                    texture: PIXI.Texture.EMPTY,
                },
            };

            for (let symbol in this.particleTextureList) {
                this.particleTextureList[symbol]['texture'] = PIXI.Texture.from(
                    this.particleTextureList[symbol]['name'] + '.png'
                );
            }            
        }
    }

    create(container: PIXI.Container, symbol: string) {
        let tempConfig = this.emitterConfig();
        this.emitter = new pixiParticles.Emitter(
            // The PIXI.Container to put the emitter in
            // if using blend modes, it's important to put this
            // on top of a bitmap, and not use the root stage Container
            //this.particleContainer,
            container,

            // The collection of particle images to use
            [ParticleEmitter.particleTextureList[symbol]['texture']],

            // Emitter configuration, edit this to change the look
            // of the emitter
            tempConfig
        );

        this.emitter.particleConstructor = pixiParticles.PathParticle;
        
        /*
            this.emitter.init(
                ParticleEmitter.particleTextureList[symbol]['texture'],
                tempConfig
            );
        */
        this.emitter.emit = true;
        //this.elapsedTime = Date.now();
        // return this.emitter;
    }
    // not be modified, and may not exist - use "new particles.Emitter()", or whatever
    // your imported namespace is
    // Calculate the current time

    // Update function every frame
    /*
    updateParticles() {
        // Update the next frame
        var now = Date.now();
        // The emitter requires the elapsed
        // number of seconds since the last update
        this.emitter.update((now - this.elapsedTime) * 0.001);
        this.elapsedTime = now;

        // Should re-render the PIXI Stage
        // renderer.render(stage);
        this.updateParticles();
        //requestAnimationFrame(this.updateParticles);
    }
    */

    startEmitting() {
        // Start emitting
        this.emitter.emit = true;        
        // Start the update
        //   this.updateParticles();
    }

    stopEmitting() {
        
        this.emitter.emit = false;
        this.emitter.cleanup();
        this.emitter.destroy();
        // this.emitter = null;
    }

    emitterConfig() {
        return {
            autoUpdate: true,
            alpha: {
                list: [
                    {
                        value: 1.0,
                        time: 0,
                    },
                    {
                        value: 0.1,
                        time: 1,
                    },
                ],
                isStepped: false,
            },
            scale: {
                list: [
                    {
                        value: 3, //1,
                        time: 0,
                    },
                    {
                        value: 1, //0.3,
                        time: 1,
                    },
                ],
                isStepped: false,
            },
            color: {
                list: [
                    {
                        value: 'ffffff',
                        time: 0,
                    },
                    {
                        value: 'ffffff',
                        time: 1,
                    },
                ],
                isStepped: false,
            },
            speed: {
                list: [
                    {
                        value: 200,
                        time: 0.5,
                    },
                    {
                        value: 10,
                        time: 1.5,
                    },
                ],
                isStepped: false,
            },
            startRotation: {
                min: 225,
                max: 315,
            },
            rotationSpeed: {
                min: 0,
                max: 90,
            },
            lifetime: {
                min: 0.1,
                max: 2,
            },
            frequency: 0.008,
            spawnChance: 1,
            particlesPerWave: 1,
            emitterLifetime: 0.5, //0.31,
            maxParticles: 10,
            pos: {
                x: 0,
                y: 0,
            },
            addAtBack: false,
            spawnType: 'rect', //'point', //'rect',
            //spawnCircle: { x: 0, y: 0, r: 10, },
            spawnRect: { x: -50, y: 50, w: 50, h: 0 }, //{ x: -100, y: -100, w: 200, h: 0 }, //200 },
            extraData: {
                path: 'sin(x*5/100)*20',
            },
        };
    }
}
export default ParticleEmitter;
